import React from 'react'
import {
  deleteBudgetConstraints,
  deleteBudgetData,
  deleteBudgetFuelUsage,
  deleteBudgetHeatCurves,
  deleteBudgetRampRate,
  deleteEfor,
  deleteFleetPeak,
  deleteGoalCA,
  deletePlannedEvent,
  deleteStartupHeat,
  deleteTrueupAdjustment,
  deleteUnavailableFactor,
  deleteVomCost,
  deleteZainetFuelPrice,
  // getAuthorization,
  // getCredentials,
  retrieveBudgetConstraints,
  retrieveBudgetData,
  retrieveBudgetFuelUsage,
  retrieveBudgetHeatCurves,
  retrieveBudgetRampRate,
  retrieveEfor,
  retrieveFleetPeak,
  retrieveGoalCA,
  retrievePlannedEvent,
  retrieveStartupHeat,
  retrieveTrueupAdjustment,
  retrieveUnavailableFactor,
  retrieveVomCost,
  retrieveZainetFuelPrice,
  saveBudgetConstraints,
  saveBudgetData,
  saveBudgetFuelUsage,
  saveBudgetHeatCurves,
  saveBudgetRampRate,
  saveEfor,
  saveFleetPeak,
  saveGoalCA,
  savePlannedEvent,
  saveStartupHeat,
  saveTrueupAdjustment,
  saveUnavailableFactor,
  saveVomCost,
  saveZainetFuelPrice,
} from 'api/pgads'
// import { Button, DatePicker, message,  } from 'antd'
// import moment from 'moment'
// import { nrgProcessMarginStartupHeatCost } from '../../api/pgads'
// import { Button, Icon, Upload } from 'antd'

const {
  dateCol,
  strCol,
  numCol,
  intCol,
} = require('@integec/grid-tools/lib/cols')
const {
  unitIdHeader,
  modifierCol,
  modifiedDateCol,
} = require('core/HeaderColTypeProps')

const zainetFuelPriceHeaders = [
  unitIdHeader,
  dateCol({
    ident: 'transDate',
    display: 'Transaction Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  strCol({
    ident: 'fuelCode',
    display: 'Fuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    dropdown: true,
  }),
  numCol({
    ident: 'fuelCost',
    display: 'Fuel Cost',
    isFiltered: true,
    displayFormat: '0.000000',
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]
const unavailableFactorHeaders = [
  unitIdHeader,
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  numCol({
    ident: 'unavailFactor',
    display: 'Unavailable Factor',
    isFiltered: true,
    // displayFormat: '0.000000',
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]
// eslint-disable-next-line no-unused-vars
const unavailableFactorHeadersExport = [
  strCol({
    ident: 'unitId',
    display: 'Unit',
    width: 350,
    isKey: true,
    sortOrder: 'asc',
    ellipsis: true,
    dataGetter: ({ rowData }) => rowData.unitId,
  }),
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  numCol({
    ident: 'unavailFactor',
    display: 'Unavailable Factor',
    isFiltered: true,
    // displayFormat: '0.000000',
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]
const plannedEventHeaders = [
  unitIdHeader,
  dateCol({
    ident: 'startDate',
    display: 'Start Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  dateCol({
    ident: 'endDate',
    display: 'End Date',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    innerCompProps: { style: { gridColumnEnd: 'span 3', width: '150px' } },
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    sortOrder: 'asc',
    width: 400,
    innerCompProps: { style: { gridColumnEnd: 'span 3' } },
  }),
  modifierCol,
  modifiedDateCol,
]
const budgetConstraintsHeaders = [
  unitIdHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    isKey: true,
    dropdown: true,
  }),

  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  strCol({
    ident: 'pfuelCode',
    display: 'Fuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    dropdown: true,
  }),
  numCol({
    ident: 'ecoMinmw',
    display: 'Eco Min MW',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'ecoMaxmw',
    display: 'Eco Max MW',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'emerMinmw',
    display: 'Emer Min MW',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'emerMaxmw',
    display: 'Emer Max MW',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'noloadCost',
    display: 'No Load Cost',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'minRuntime',
    display: 'Min Runtime',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'maxRuntime',
    display: 'Max Runtime',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'minDowntime',
    display: 'Min Downtime',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'hot2coldTime',
    display: 'Hot To Cold Time',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'hot2interTime',
    display: 'Hot To Inter Time',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'coldStartupTime',
    display: 'Cold Startup Time',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'interStartupTime',
    display: 'Inter Startup Time',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'hotStartupTime',
    display: 'Hot Startup Time',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'maxDailyStarts',
    display: 'Max Daily Starts',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]
const budgetFuelUsageHeaders = [
  unitIdHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
    sortOrder: 'desc',
    width: 100,
    dropdown: true,
  }),
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  strCol({
    ident: 'pfuelCode',
    display: 'Fuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    dropdown: true,
  }),
  strCol({
    ident: 'startFuelCode',
    display: 'Start Fuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    dropdown: true,
  }),
  modifierCol,
  modifiedDateCol,
]
const budgetDataHeaders = [
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
    sortOrder: 'desc',
    dropdown: true,
  }),
  unitIdHeader,
  intCol({
    ident: 'month',
    display: 'Month',
    isKey: true,
    sortOrder: 'asc',
    dropdown: true,
  }),
  strCol({ ident: 'rollupId', display: 'Rollup ID', isFiltered: true }),
  numCol({ ident: 'poh', display: 'POH', isFiltered: true }),
  numCol({ ident: 'sh', display: 'SH', isFiltered: true }),
  numCol({ ident: 'netGen', display: 'Net Gen', isFiltered: true }),
  numCol({ ident: 'actlStart', display: 'Actual Start', isFiltered: true }),
  numCol({ ident: 'atmptStart', display: 'Attempt Start', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
]
const goalCAHeaders = [
  unitIdHeader,
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  numCol({
    ident: 'goalCa',
    display: 'Goal CA',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'goalEnergyMargin',
    display: 'Goal Energy Margin',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'goalLossMargin',
    display: 'GoalLossMargin',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]
const vomCostHeaders = [
  unitIdHeader,
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  strCol({
    ident: 'pfuelCode',
    display: 'Fuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    dropdown: true,
  }),
  numCol({
    ident: 'omCost',
    display: 'OmCost',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]
const eforHeaders = [
  unitIdHeader,
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  numCol({
    ident: 'efor',
    display: 'EFOR',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]
const fleetPeakHeaders = [
  unitIdHeader,
  numCol({
    ident: 'jan',
    display: 'Jan',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    innerCompProps: { min: -9, max: 9 },
  }),
  numCol({
    ident: 'feb',
    display: 'Feb',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    innerCompProps: { min: -9, max: 9 },
  }),
  numCol({
    ident: 'mar',
    display: 'Mar',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    innerCompProps: { min: -9, max: 9 },
  }),
  numCol({
    ident: 'apr',
    display: 'Apr',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    innerCompProps: { min: -9, max: 9 },
  }),
  numCol({
    ident: 'may',
    display: 'May',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    innerCompProps: { min: -9, max: 9 },
  }),
  numCol({
    ident: 'jun',
    display: 'Jun',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    innerCompProps: { min: -9, max: 9 },
  }),
  numCol({
    ident: 'jul',
    display: 'Jul',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    innerCompProps: { min: -9, max: 9 },
  }),
  numCol({
    ident: 'aug',
    display: 'Aug',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    innerCompProps: { min: -9, max: 9 },
  }),
  numCol({
    ident: 'sep',
    display: 'Sep',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    innerCompProps: { min: -9, max: 9 },
  }),
  numCol({
    ident: 'oct',
    display: 'Oct',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    innerCompProps: { min: -9, max: 9 },
  }),
  numCol({
    ident: 'nov',
    display: 'Nov',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    innerCompProps: { min: -9, max: 9 },
  }),
  numCol({
    ident: 'dec',
    display: 'Dec',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
    innerCompProps: { min: -9, max: 9 },
  }),
  modifierCol,
  modifiedDateCol,
]
const trueupAdjustmentHeaders = [
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
    sortOrder: 'desc',
    dropdown: true,
  }),
  unitIdHeader,
  intCol({
    ident: 'month',
    display: 'Month',
    isKey: true,
    sortOrder: 'asc',
    dropdown: true,
  }),
  numCol({
    ident: 'trueupAdjustment',
    display: 'Trueup Adjustment',
    isFiltered: true,
    displayFormat: '0.000000',
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    isFiltered: true,
    sortOrder: 'asc',
    width: 450,
    innerCompProps: { style: { gridColumnEnd: 'span 3' } },
  }),
  modifierCol,
  modifiedDateCol,
]
const startupHeatHeaders = [
  unitIdHeader,
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  strCol({
    ident: 'startupFuelcode',
    display: 'Startup Fuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    dropdown: true,
  }),
  numCol({
    ident: 'startupHeat',
    display: 'Startup Heat',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  numCol({
    ident: 'additionalStartupCost',
    display: 'Adt. Startup Cost',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

const budgetHeatCurve = [
  //   strCol({ ident: 'unitid', display: 'Unitid', isKey: true, sortOrder: 'asc' }),
  unitIdHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
    dropdown: true,
  }),
  dateCol({
    ident: 'effectiveDate',
    display: 'Effectivedate',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  numCol({
    ident: 'endMw',
    display: 'End MW',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    // ...toSelectionColProps(seasonChioce),
  }),
  numCol({
    ident: 'acoEfficient',
    display: 'A-Coefficient',
    isFiltered: true,
    displayFormat: '0.00000',
    // sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'bcoEfficient',
    display: 'B-Coefficient',
    isFiltered: true,
    displayFormat: '0.00000',
    // sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'ccoEfficient',
    display: 'C-Coefficient',
    isFiltered: true,
    displayFormat: '0.000000',
    // sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'dcoEfficient',
    display: 'D-Coefficient',
    isFiltered: true,
    displayFormat: '0.000000',
    // sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'perfFactor',
    display: 'Performance Factor',
    isFiltered: true,
    // sortOrder: 'asc',
    displayFormat: '0.000000',
    width: 200,
  }),
  modifierCol,
  modifiedDateCol,
]

const budgetRampRate = [
  //   strCol({ ident: 'unitid', display: 'Unitid', isKey: true, sortOrder: 'asc' }),
  intCol({ ident: 'year', display: 'Year', isKey: true, dropdown: true }),
  unitIdHeader,
  dateCol({
    ident: 'effectiveDate',
    display: 'Effectivedate',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  numCol({
    ident: 'mwLoad',
    display: 'MW Load',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'rampRate',
    display: 'Ramp Rate',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

export const NRGMarginImportScreens = [
  'marginanalysis-zainetfuelprice',
  'marginanalysis-unavailablefactor',
  'marginanalysis-budgetconstraints',
  'marginanalysis-budgetfuelusage',
  'marginanalysis-budgetdata',
  'marginanalysis-plannedevent',
  'marginanalysis-goalca',
  'marginanalysis-vomcost',
  'marginanalysis-efor',
  'marginanalysis-fleetpeak',
  'marginanalysis-trueupadjustment',
  'marginanalysis-oastartupheat',
]

export const GENONMarginImportScreens = [
  // 'marginanalysis-oapricedata',
  'marginanalysis-budgetheatcurve',
  'marginanalysis-budgetramprate',
]

// const ImportData = ({
//   apiTargetInfo,
//   pathUrl,
//   setSpinning,
//   onRetrieve,
//   onFileUploadChange = _ => _,
// }) => {
//   const url = _ => `${apiTargetInfo.baseUrl}/${pathUrl}`

//   const fileProps = {
//     name: 'file',
//     action: url(),
//     method: 'POST',
//     headers: getAuthorization(apiTargetInfo),
//     ...getCredentials(apiTargetInfo),
//   }
//   return (
//     <Upload
//       {...fileProps}
//       onChange={data => {
//         setSpinning(true)
//         onFileUploadChange(data)
//         onRetrieve()
//       }}
//       multiple={false}
//       showUploadList={false}
//     >
//       <Button type="danger">
//         <Icon type="upload" /> Click to Upload
//       </Button>
//     </Upload>
//   )
// }

const screenProps = {
  'marginanalysis-zainetfuelprice': {
    title: 'Zaniet Fuel Price',
    headers: zainetFuelPriceHeaders,
    commonScreenProps: {
      withDatePicker: true,
      withDatePickerTitle: 'Effective Date : ',
    },
    insertCompProps: {
      gridTemplateColumns:
        '100px 150px 200px 150px 120px 150px 120px 120px 120px 130px',
    },
    saveTask: saveZainetFuelPrice,
    retrieveTask: retrieveZainetFuelPrice,
    deleteTask: deleteZainetFuelPrice,
  },
  'marginanalysis-unavailablefactor': {
    title: 'Unavailable Factor',
    headers: unavailableFactorHeaders,
    commonScreenProps: {
      withDatePicker: true,
      withDatePickerTitle: 'Effective Date : ',
      // exportHeader: unavailableFactorHeadersExport,
      // extraCriteriaAfterButton: props => (
      //   <ImportData
      //     {...props}
      //     pathUrl="marginanalysisdata/unavailable-factor/import"
      //   />
      // ),
      withImport: true,
      importUrl: 'marginanalysisdata-import/generic-import',
      importData: { importType: 'MA_UNAVAIL_FACTOR' },
    },
    insertCompProps: {
      gridTemplateColumns:
        '100px 150px 200px 150px 110px 150px 130px 140px 140px 100px',
      fillerSpan: 0,
    },
    saveTask: saveUnavailableFactor,
    retrieveTask: retrieveUnavailableFactor,
    deleteTask: deleteUnavailableFactor,
  },
  'marginanalysis-budgetconstraints': {
    title: 'Budget Constraints',
    headers: budgetConstraintsHeaders,
    criteria: { showYear: true },
    commonScreenProps: {
      withDatePicker: true,
      withDatePickerTitle: 'Effective Date : ',
    },
    saveTask: saveBudgetConstraints,
    retrieveTask: retrieveBudgetConstraints,
    deleteTask: deleteBudgetConstraints,
    insertCompProps: {
      gridTemplateColumns:
        '120px 150px 200px 150px 120px 130px 120px 140px 120px 130px',
      fillerSpan: 0,
    },
  },
  'marginanalysis-budgetfuelusage': {
    title: 'Budget Fuel Usage',
    headers: budgetFuelUsageHeaders,
    criteria: { showYear: true },
    commonScreenProps: {
      withDatePicker: true,
      withDatePickerTitle: 'Effective Date : ',
    },
    insertCompProps: {
      gridTemplateColumns:
        '120px 150px 200px 150px 100px 120px 120px 150px 120px 130px',
      fillerSpan: 6,
    },
    saveTask: saveBudgetFuelUsage,
    retrieveTask: retrieveBudgetFuelUsage,
    deleteTask: deleteBudgetFuelUsage,
  },
  'marginanalysis-budgetdata': {
    title: 'Budget Data',
    headers: budgetDataHeaders,
    criteria: { showYear: true, showMonth: true },
    commonScreenProps: {},
    insertCompProps: {
      gridTemplateColumns:
        '100px 150px 200px 150px 120px 120px 120px 140px 120px 120px',
    },
    saveTask: saveBudgetData,
    retrieveTask: retrieveBudgetData,
    deleteTask: deleteBudgetData,
  },
  'marginanalysis-plannedevent': {
    title: 'Planned Event',
    headers: plannedEventHeaders,
    criteria: { showDateRange: true },
    commonScreenProps: {},
    insertCompProps: { fillerSpan: 4 },
    saveTask: savePlannedEvent,
    retrieveTask: retrievePlannedEvent,
    deleteTask: deletePlannedEvent,
  },
  'marginanalysis-goalca': {
    title: 'Goal CA',
    headers: goalCAHeaders,
    commonScreenProps: {
      withDatePicker: true,
      withDatePickerTitle: 'Effective Date : ',
      withImport: true,
      importUrl: 'marginanalysisdata-import/generic-import',
      importData: { importType: 'MA_GOAL_CA' },
    },
    insertCompProps: {
      gridTemplateColumns:
        '120px 150px 200px 150px 120px 150px 100px 120px 140px 120px',
      fillerSpan: 6,
    },
    saveTask: saveGoalCA,
    retrieveTask: retrieveGoalCA,
    deleteTask: deleteGoalCA,
  },
  'marginanalysis-vomcost': {
    title: 'Vom Cost',
    headers: vomCostHeaders,
    commonScreenProps: {
      withDatePicker: true,
      withDatePickerTitle: 'Effective Date : ',
      withImport: true,
      importUrl: 'marginanalysisdata-import/generic-import',
      importData: { importType: 'MA_VOM_COST' },
    },
    insertCompProps: {
      gridTemplateColumns:
        '100px 150px 200px 150px 120px 150px 120px 120px 100px 150px',
    },
    saveTask: saveVomCost,
    retrieveTask: retrieveVomCost,
    deleteTask: deleteVomCost,
  },
  'marginanalysis-efor': {
    title: 'EFOR',
    headers: eforHeaders,
    commonScreenProps: {
      withDatePicker: true,
      withDatePickerTitle: 'Effective Date : ',
    },
    insertCompProps: {
      gridTemplateColumns:
        '100px 150px 200px 150px 120px 150px 100px 150px 140px 100px',
      fillerSpan: 0,
    },
    saveTask: saveEfor,
    retrieveTask: retrieveEfor,
    deleteTask: deleteEfor,
  },
  'marginanalysis-fleetpeak': {
    title: 'Fleet Peak Definition',
    headers: fleetPeakHeaders,
    useDefaultUnit: true,
    commonScreenProps: {},
    insertCompProps: { fillerSpan: 0 },
    saveTask: saveFleetPeak,
    retrieveTask: retrieveFleetPeak,
    deleteTask: deleteFleetPeak,
    beforeInsertData: d => ({ ...d, unit: d.unit.substr(3) }),
  },
  'marginanalysis-trueupadjustment': {
    title: 'Trueup Adjustment',
    headers: trueupAdjustmentHeaders,
    criteria: { showYear: true, showMonth: true },
    commonScreenProps: {},
    insertCompProps: {
      gridTemplateColumns:
        '110px 150px 200px 150px 100px 130px 100px 130px 140px 140px',
      fillerSpan: 4,
    },
    saveTask: saveTrueupAdjustment,
    retrieveTask: retrieveTrueupAdjustment,
    deleteTask: deleteTrueupAdjustment,
  },
  'marginanalysis-oastartupheat': {
    title: 'Startup Heat',
    headers: startupHeatHeaders,
    // extraCriteriaAfterButton: commonMarginProps => {
    //   const { CLIENT, targetInfo, setError } = commonMarginProps || {}
    //   if (CLIENT !== 'NRG') {
    //     return <div />
    //   }
    //   const Func = prop2 => {
    //     const [dates, setDates] = React.useState([
    //       moment().startOf('month'),
    //       moment(),
    //     ])
    //     const [open, setOpen] = React.useState(false)
    //     return (
    //       <div style={{ border: '1px solid', padding: '5px' }}>
    //         {/* <label>Month Range :</label> */}
    //         <DatePicker.RangePicker
    //           value={dates}
    //           mode={['month', 'month']}
    //           format="MMM-YYYY"
    //           open={open}
    //           onOpenChange={status => {
    //             if (status) setOpen(true)
    //           }}
    //           onPanelChange={value => {
    //             setDates(value)
    //             setOpen(false)
    //           }}
    //           style={{ marginLeft: '10px', width: '250px' }}
    //         />
    //         <Button
    //           onClick={_ =>
    //             processNrgStartupHeat(
    //               targetInfo,
    //               dates,
    //               setError,
    //               prop2.selectedUnits || [],
    //               prop2.setSpinning
    //             )
    //           }
    //           style={{ marginLeft: '10px' }}
    //         >
    //           Process Startup Heat Cost
    //         </Button>
    //       </div>
    //     )
    //   }
    //   return prop2 => <Func {...prop2} />
    // },
    commonScreenProps: {
      withDatePicker: true,
      withDatePickerTitle: 'Effective Date : ',
      withImport: true,
      importUrl: 'marginanalysisdata-import/generic-import',
      importData: { importType: 'MA_STARTUP_HEAT' },
    },
    insertCompProps: {
      fillerSpan: 6,
    },
    saveTask: saveStartupHeat,
    retrieveTask: retrieveStartupHeat,
    deleteTask: deleteStartupHeat,
  },
  'marginanalysis-budgetheatcurve': {
    title: 'Budget Heat Curves',
    headers: budgetHeatCurve,
    criteria: { showYear: true },
    commonScreenProps: {
      withDatePicker: true,
      withDatePickerTitle: 'Effective Date : ',
    },
    saveTask: saveBudgetHeatCurves,
    retrieveTask: retrieveBudgetHeatCurves,
    deleteTask: deleteBudgetHeatCurves,
  },
  'marginanalysis-budgetramprate': {
    title: 'Budget Ramp Rate',
    headers: budgetRampRate,
    criteria: { showYear: true },
    commonScreenProps: {
      withDatePicker: true,
      withDatePickerTitle: 'Effective Date : ',
    },
    insertCompProps: {
      gridTemplateColumns:
        '100px 150px 210px 150px 100px 150px 120px 150px 100px 140px',
      fillerSpan: 6,
    },
    saveTask: saveBudgetRampRate,
    retrieveTask: retrieveBudgetRampRate,
    deleteTask: deleteBudgetRampRate,
  },
}

const getScreenInfo = key => screenProps[key]

export default getScreenInfo

// const processNrgStartupHeat = (
//   targetInfo,
//   date,
//   setError,
//   selectedUnits,
//   setSpinning
// ) => {
//   setSpinning(true)
//   nrgProcessMarginStartupHeatCost(
//     targetInfo,
//     date,
//     selectedUnits.map(u => u.unitId)
//   ).fork(setError, _ => {
//     setSpinning(false)
//     message.success(
//       'Process completed successfully.Please retrieve data to see the updated startup heat cost.'
//     )
//   })
// }
